const overrides = {
  light: {
    MuiFormLabel: {
      root: {
        color: 'rgba(0,0,0,0.38)',
      },
    },
    MuiFormControlLabel: {
      label: {
        color: 'rgba(0,0,0,0.87)',
      },
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        margin: 0,
        height: 'auto',
      },
    },
    MuiTableCell: {
      sizeSmall: {
        padding: '0 8px',
        height: '48px',
      },
    },
    MuiButton: {
      containedPrimary: {
        borderRadius: '4px',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,
        boxShadow: 'none',
        '&$disabled': {
          background: '#f5f5f5',
          color: 'rgba(0, 0, 0, 0.38)',
          boxShadow: 'none',
        },
      },
      outlinedPrimary: {
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,
        borderWidth: '1px',
        borderStyle: 'solid',
        // '&:hover': {
        //   backgroundColor: 'rgba(0, 30, 255, 0.04)',
        // },
        '&:disabled': {
          borderRadius: 4,
          border: 'solid 1px rgba(0, 0, 0, 0.12)',
        },
      },
      textPrimary: {
        paddingLeft: 12,
        paddingTop: 8,
        paddingBottom: 8,
        // '&:hover': {
        //   backgroundColor: 'rgba(0, 30, 255, 0.04)',
        // },
        '&$disabled': {
          color: 'rgba(0, 0, 0, 0.38)',
          boxShadow: 'none',
        },
      },
      text: {
        paddingLeft: 12,
        paddingTop: 8,
        paddingBottom: 8,
        '&:hover': {
          backgroundColor: 'rgba(0, 30, 255, 0.04)',
        },
        '&$disabled': {
          color: 'rgba(0, 0, 0, 0.38)',
          boxShadow: 'none',
        },
      },
      label: {
        textTransform: 'none',
      },
    },
    MuiFab: {
      extended: {
        height: 36,
        paddingLeft: 12,
        borderRadius: '4px',
      },
      primary: {
        boxShadow: 'none',
      },
    },
    MuiExpansionPanelSummary: {
      expandIcon: {
        padding: 0,
        marginBottom: 16,
        marginRight: -16,
        marginTop: 16,
      },
    },
    MuiTooltip: {
      tooltip: {
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.14)',
        backgroundColor: '#f5f5f5',
        color: 'rgba(18, 18, 18, 0.87)',
        fontSize: 12,
        paddingLeft: 12,
        paddingRight: 12,
      },
      popper: {
        zIndex: 2147483647,
      },
    },
    MuiBreadcrumbs: {
      separator: {
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      },
      daysHeader: {
        paddingTop: 12,
        '& span': {
          color: 'rgba(0,0,0,0.87)',
        },
      },
      iconButton: {
        backgroundColor: 'transparent',
        '& .MuiIconButton-label': {
          color: 'rgba(0, 0, 0, 0.6)',
        },
      },
      transitionContainer: {
        '& p': {
          color: 'rgba(0, 0, 0, 0.87)',
        },
      },
      dayLabel: {
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        marginBottom: 20,
      },
    },
    MuiPickersDay: {
      day: {
        color: 'rgba(0, 0, 0, 0.87)',
        '&:hover': {
          backgroundColor: 'rgba(0, 30, 255, 0.08)',
        },
      },
      daySelected: {
        backgroundColor: '#001eff',
        '&:hover': {
          color: 'rgba(255, 255, 255, 0.87)',
        },
      },
      current: {
        color: '#001eff',
        '&:hover': {
          backgroundColor: 'rgba(0, 30, 255, 0.08)',
        },
      },
    },
    MuiInputAdornment: {
      root: {
        zIndex: 1,
      },
    },
    MuiOutlinedInput: {
      root: {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          border: 'solid 1px #000',
        },
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline,&:hover .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #001eff',
          },
        },
        '&.Mui-disabled': {
          '& input': {
            color: 'rgba(0, 0, 0, 0.2)',
          },
          '& .MuiOutlinedInput-notchedOutline,&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'solid 1px rgba(0, 0, 0, 0.2)',
            color: 'rgba(0, 0, 0, 0.38)',
          },
        },
        '&.Mui-error': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ff001e',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#b20015',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#b20015',
          },
          '&.Mui-focused:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#b20015',
          },
        },
      },
      notchedOutline: {
        border: 'solid 1px rgba(0, 0, 0, 0.3)',
      },
      inputAdornedEnd: {
        zIndex: 1,
      },
      input: {
        zIndex: 1,
        color: 'rgba(0,0,0,0.87)',
        '&:readonly': {
          color: 'rgba(0, 0, 0, 0.2)',
        },
        padding: '14.5px 14px',
      },
    },
    MuiInputLabel: {
      outlined: {
        color: 'rgba(0, 0, 0, 0.87)',
        '&.Mui-focused': {
          color: '#001eff',
        },
        '&.Mui-disabled': {
          color: 'rgba(0, 0, 0, 0.2)',
        },
        '&.Mui-error': {
          '&.Mui-focused': {
            color: '#b20015',
            '&:hover': {
              color: '#b20015',
            },
          },
        },
        lineHeight: 0.5,
        '&.MuiInputLabel-marginDense': {
          lineHeight: 1.5,
        },
        '&.MuiInputLabel-shrink': {
          lineHeight: 1,
        },
      },
    },
    MuiAutocomplete: {
      paper: {
        background: '#fff',
      },
      listbox: {
        background: '#fff',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: 14,
      },
      option: {
        '&:hover': {
          background: 'rgba(0, 0, 0, 0.05)',
        },
        '&[aria-selected="true"]': {
          backgroundColor: '#fff',
          color: '#001eff',
        },
        '&.Mui-disabled': {
          color: 'rgba(0, 0, 0, 0.38)',
        },
      },
      noOptions: {
        color: 'rgba(0, 0, 0, 0.87)',
      },
      loading: {
        color: 'rgba(0, 0, 0, 0.87)',
      },
      inputRoot: {
        '&[class*="MuiOutlinedInput-root"]': {
          padding: '5px 4px',
          '&[class*="MuiOutlinedInput-marginDense"]': {
            padding: '10px 4px',
          },
        },
        '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
          padding: '5px 4px',
        },
      },
      endAdornment: {
        '& button': {
          color: 'rgba(0, 0, 0, 0.6)',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
          },
        },
      },
    },
    MuiDialog: {
      paper: {
        width: 600,
        backgroundColor: '#fff',
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          top: 0,
          left: 0,
          width: 8,
          height: '100%',
          display: 'block',
          position: 'absolute',
          content: '""',
          background: '#001eff',
          boxSizing: 'border-box',
        },
      },
      title: {
        paddingTop: 24,
        paddingLeft: 32,
        paddingRight: 24,
        paddingBottom: 8,
      },
      content: {
        paddingTop: 24,
        paddingLeft: 32,
        paddingRight: 24,
        paddingBottom: 8,
      },
    },
    MuiDialogTitle: {
      root: {
        paddingTop: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingBottom: 8,
      },
    },
    MuiDialogContent: {
      root: {
        overflow: 'hidden',
        '& p': {
          color: 'rgba(0,0,0,0.87)',
        },
      },
    },
    MuiDialogActions: {
      root: {
        margin: 0,
        padding: '24px',
      },
    },
    MuiTextField: {
      root: {
        '&:hover': {
          '& .MuiInputLabel-outlined.Mui-error,& .MuiFormLabel-asterisk.Mui-error': {
            color: '#b20015',
          },
        },
        '& .MuiInputAdornment-root .MuiButtonBase-root.MuiIconButton-root': {
          padding: 8,
        },
      },
    },
  },
  dark: {
    MuiFormLabel: {
      root: {
        color: 'rgba(0,0,0,0.38)',
      },
    },
    MuiFormControlLabel: {
      label: {
        color: 'rgba(0,0,0,0.38)',
      },
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        margin: 0,
        height: 'auto',
      },
    },
    MuiTableCell: {
      sizeSmall: {
        padding: '0 8px',
        height: '48px',
      },
    },
    MuiButton: {
      containedPrimary: {
        borderRadius: '4px',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,
        boxShadow: 'none',
        '&$disabled': {
          background: '#f5f5f5',
          color: 'rgba(0, 0, 0, 0.38)',
          boxShadow: 'none',
        },
      },
      outlinedPrimary: {
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,
        borderWidth: '1px',
        borderStyle: 'solid',
        // '&:hover': {
        //   backgroundColor: 'rgba(0, 30, 255, 0.04)',
        // },
        '&:disabled': {
          borderRadius: 4,
          border: 'solid 1px rgba(0, 0, 0, 0.12)',
        },
      },
      textPrimary: {
        paddingLeft: 12,
        paddingTop: 8,
        paddingBottom: 8,
        '&$disabled': {
          color: 'rgba(0, 0, 0, 0.38)',
          boxShadow: 'none',
        },
      },
      text: {
        paddingLeft: 12,
        paddingTop: 8,
        paddingBottom: 8,
        '&:hover': {
          backgroundColor: 'rgba(0, 30, 255, 0.04)',
        },
        '&$disabled': {
          color: 'rgba(0, 0, 0, 0.38)',
          boxShadow: 'none',
        },
      },
      label: {
        textTransform: 'none',
      },
    },
    MuiFab: {
      extended: {
        height: 36,
        paddingLeft: 12,
        borderRadius: '4px',
      },
      primary: {
        boxShadow: 'none',
      },
    },
    MuiExpansionPanelSummary: {
      expandIcon: {
        padding: 0,
        marginBottom: 16,
        marginRight: -16,
        marginTop: 16,
      },
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: '#333333',
        color: '#cccccc',
        fontSize: 12,
        paddingLeft: 12,
        paddingRight: 12,
      },
      popper: {
        zIndex: 2147483647,
      },
    },
    MuiBreadcrumbs: {
      separator: {
        color: '#ccc',
      },
    },
    MuiPickersBasePicker: {
      container: {
        background: '#121212',
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        marginBottom: 20,
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
      },
      daysHeader: {
        paddingTop: 12,
        '& span': {
          color: '#ccc',
        },
      },
      iconButton: {
        backgroundColor: 'transparent',
        color: 'rgba(0,0,0,0.6)',
        '& .MuiIconButton-label': {
          color: '#ccc',
        },
      },
      transitionContainer: {
        '& p': {
          color: '#ccc',
        },
      },
      dayLabel: {
        color: '#ccc',
      },
    },
    MuiPickersDay: {
      day: {
        color: 'rgba(255, 255, 255, 0.5)',
        '&:hover': {
          backgroundColor: 'rgba(102, 120, 255, 0.2)',
        },
      },
      daySelected: {
        color: '#fff',
        backgroundColor: '#334bff',
        '&:hover': {
          color: '#ccc',
        },
      },
      current: {
        color: '#6678ff',
        '&:hover': {
          backgroundColor: 'rgba(102, 120, 255, 0.2)',
        },
      },
    },
    MuiInputAdornment: {
      root: {
        zIndex: 1,
      },
    },
    MuiOutlinedInput: {
      root: {
        '&:hover': {
          '&  .MuiOutlinedInput-notchedOutline': {
            border: 'solid 1px #f8f8f8',
          },
        },
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #6678ff',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #6678ff',
          },
        },
        '&.Mui-disabled': {
          '& input': {
            color: 'rgba(255, 255, 255, 0.5)',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'solid 1px #404040',
            color: 'rgba(255, 255, 255, 0.5)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'solid 1px #404040',
            color: 'rgba(255, 255, 255, 0.5)',
          },
        },
        '&.Mui-error': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f5475b',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f5475b',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f5475b',
          },
          '&.Mui-focused:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f5475b',
          },
        },
      },
      notchedOutline: {
        border: 'solid 1px',
        borderColor: '#ccc',
      },
      inputAdornedEnd: {
        zIndex: 1,
      },
      input: {
        zIndex: 1,
        color: '#fff',
        padding: '14.5px 14px',
      },
    },
    MuiInputLabel: {
      outlined: {
        color: '#ccc',
        '&.Mui-focused': {
          color: '#6678ff',
        },
        '&.Mui-disabled': {
          color: 'rgba(255, 255, 255, 0.5)',
        },
        lineHeight: 0.5,
        '&.MuiInputLabel-marginDense': {
          lineHeight: 1.5,
        },
        '&.MuiInputLabel-shrink': {
          lineHeight: 1,
        },
      },
    },
    MuiAutocomplete: {
      paper: {
        background: '#262626',
      },
      listbox: {
        background: '#262626',
        color: '#ccc',
        fontSize: 14,
      },
      option: {
        '&:hover': {
          background: '#333',
        },
        '&[aria-selected="true"]': {
          backgroundColor: '#262626',
          color: '#6678ff',
        },
        '&.Mui-disabled': {
          color: 'rgba(255, 255, 255, 0.5)',
        },
      },
      noOptions: {
        color: '#ccc',
      },
      loading: {
        color: '#ccc',
      },
      inputRoot: {
        '&[class*="MuiOutlinedInput-root"]': {
          padding: '5px 4px',
          '&[class*="MuiOutlinedInput-marginDense"]': {
            padding: '10px 4px',
          },
        },
        '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
          padding: '5px 4px',
        },
      },
      endAdornment: {
        '& button': {
          color: '#ccc',
          '&:hover': {
            backgroundColor: '#333',
          },
        },
      },
    },
    MuiDialog: {
      paper: {
        width: 600,
        backgroundColor: '#262626',
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          top: 0,
          left: 0,
          width: 8,
          height: '100%',
          display: 'block',
          position: 'absolute',
          content: '""',
          background: '#334bff',
          boxSizing: 'border-box',
        },
      },
      paperWidthSm: {
        overflow: 'hidden',
      },
      title: {
        paddingTop: 24,
        paddingLeft: 32,
        paddingRight: 24,
        paddingBottom: 8,
      },
      content: {
        paddingTop: 24,
        paddingLeft: 32,
        paddingRight: 24,
        paddingBottom: 8,
      },
    },
    MuiDialogTitle: {
      root: {
        paddingTop: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingBottom: 8,
        '& h2': {
          color: '#fff',
        },
        '& h2 span': {
          top: 0,
          left: 0,
          width: 8,
          height: 100,
          display: 'block',
          position: 'absolute',
          background: '#334bff',
          boxSizing: 'border-box',
          minHeight: 220,
        },
      },
    },
    MuiDialogContent: {
      root: {
        overflow: 'hidden',
        '& p': {
          color: '#ccc',
        },
      },
    },
    MuiDialogActions: {
      root: {
        margin: 0,
        padding: '24px',
      },
    },
    MuiTextField: {
      root: {
        '& .MuiInputLabel-outlined.Mui-error, & .MuiFormLabel-asterisk.Mui-error': {
          color: '#f5475b',
        },
        '&:hover': {
          '& .MuiInputLabel-outlined.Mui-error,& .MuiFormLabel-asterisk.Mui-error': {
            color: '#f5475b',
          },
        },
        '& .MuiInputAdornment-root .MuiButtonBase-root.MuiIconButton-root': {
          padding: 8,
        },
      },
    },
  },
};

export default overrides;
